<div class="row p-2">
  <form class="needs-validation" novalidate [formGroup]="formDetail">
    <div class="row">
      <div class="col-lg-2 col-md-4 col-sm-6 col-12">
        <app-custom-input-text formControlName="document" [labelText]="'Documento'"></app-custom-input-text>
      </div>
      <div class="col-lg-2 col-md-3 col-sm-6 col-12">
        <app-custom-input-text formControlName="consecutive" [labelText]="'Número Doc.'"></app-custom-input-text>
      </div>
      <div class="col-lg-2 col-md-3 col-sm-6 col-12">
        <app-custom-input-decimal formControlName="transportValuePay"
          [labelText]="'Vr. Acordado'"></app-custom-input-decimal>
      </div>
      <div class="col-lg-2 col-md-4 col-sm-6 col-12">
        <app-custom-input-decimal formControlName="transportValueInvoiced" [labelText]="'Vr. Facturado'"
          [required]="true"></app-custom-input-decimal>
      </div>
      <div class="col-lg-2 col-md-4 col-sm-6 col-12 d-flex align-items-end gap-1 mt-2">
        <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [severity]="'primary'"
          (onClick)="save()"></app-custom-button>
        <app-custom-button [title]="'Cancelar'" [label]="'Cancelar'" [severity]="'danger'"
          (onClick)="cancel()"></app-custom-button>
      </div>
    </div>
  </form>
</div>